module.exports = require('./_global');


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_path.js
 **/